import { connect } from 'react-redux';
import { DrivePermissionsErrorModal } from '../../components/DrivePermissionsErrorModal/DrivePermissionsErrorModal';
import { onClose } from './events/onClose';
import { IDrivePermissionsErrorModalEvents } from '../../components/DrivePermissionsErrorModal/types';
import { onClick } from './events/onClick';

const mapDispatchToProps = (
    dispatch: any,
): IDrivePermissionsErrorModalEvents => {
    return {
        onClick: (source) => dispatch(onClick(source)),
        onClose: () => dispatch(onClose()),
    }
};

export const DrivePermissionsErrorModalHOC = connect(
    null,
    mapDispatchToProps
)(DrivePermissionsErrorModal);

DrivePermissionsErrorModalHOC.displayName = 'DrivePermissionsErrorModalHOC';
